module.exports = __webpack_public_path__ + "static/media/400083_01.952369a7.png";